<template>
  <div class="content">
    <div class="page-inner">
      <div class="mb-4">
        <h1>
          AI <span class="text-primary fw-bold">Cover Art</span> Generator
        </h1>
        <div class="text-right">
          <span class="badge badge-warning">
            {{ available }} {{ $t('available_this_month') }}
          </span>
        </div>
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tab === 'generator' }" aria-current="page" href="javascript:void(0)" @click="tab = 'generator'">
            {{ $t('generator') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tab === 'covers' }" href="javascript:void(0)" @click="tab = 'covers'">
            {{ $t('my_covers') }}
          </a>
        </li>
      </ul>
      <div class="card" v-if="loading || url" v-show="tab === 'generator'">
        <div class="card-body text-center">
          <div v-if="loading" class="p-3">
            <i class="fa fa-spinner fa-spin text-muted"></i>
          </div>
          <a :download="`indiefy-ai-cover-${new Date().getTime()}.jpg`" :href="url" title="AI Cover" target="_blank" class="d-inline-block">
            <img :src="url" alt="" v-if="url" width="80%">
          </a>
          <div v-if="url" class="mt-2">
            <button type="button" class="btn btn-default" @click="download()">
              {{ $t('download') }}
            </button>
          </div>
        </div>
      </div>
      <div class="card" v-show="tab === 'generator'">
        <div class="card-body">
          <div class="form-group">
            <label for="">{{ $t('artistic_style') }}</label>
            <select class="form-control" v-model="style">
              <option value="synthwave-80s">{{ $t('synthwave-80s') }}</option>
              <option value="minimalist">{{ $t('minimalist') }}</option>
              <option value="grunge">{{ $t('grunge') }}</option>
              <option value="psychedelic">{{ $t('psychedelic') }}</option>
              <option value="abstract-modern">{{ $t('abstract-modern') }}</option>
              <option value="cyberpunk">{{ $t('cyberpunk') }}</option>
              <option value="vintage">{{ $t('vintage') }}</option>
              <option value="street-art">{{ $t('street-art') }}</option>
              <option value="fantasy">{{ $t('fantasy') }}</option>
              <option value="pop-art">{{ $t('pop-art') }}</option>
              <option value="gothic">{{ $t('gothic') }}</option>
              <option value="surrealism">{{ $t('surrealism') }}</option>
              <option value="baroque">{{ $t('baroque') }}</option>
              <option value="cartoon">{{ $t('cartoon') }}</option>
              <option value="photorealistic">{{ $t('photorealistic') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">{{ $t('color_style') }}</label>
            <select class="form-control" v-model="color">
              <option value="neons">{{ $t('neons') }}</option>
              <option value="dark-tones">{{ $t('dark-tones') }}</option>
              <option value="warm-colors">{{ $t('warm-colors') }}</option>
              <option value="pastels">{{ $t('pastels') }}</option>
              <option value="black-and-white">{{ $t('black-and-white') }}</option>
              <option value="earth-tones">{{ $t('earth-tones') }}</option>
              <option value="cool-tones">{{ $t('cool-tones') }}</option>
              <option value="sunset-hues">{{ $t('sunset-hues') }}</option>
              <option value="monochrome">{{ $t('monochrome') }}</option>
              <option value="metallics">{{ $t('metallics') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">{{ $t('background') }}</label>
            <select class="form-control" v-model="background">
              <option value="futuristic-cityscape">{{ $t('futuristic-cityscape') }}</option>
              <option value="nature-landscape">{{ $t('nature-landscape') }}</option>
              <option value="outer-space">{{ $t('outer-space') }}</option>
              <option value="recording-studio">{{ $t('recording-studio') }}</option>
              <option value="abstract-background">{{ $t('abstract-background') }}</option>
              <option value="desert-landscape">{{ $t('desert-landscape') }}</option>
              <option value="underwater">{{ $t('underwater') }}</option>
              <option value="mountain-view">{{ $t('mountain-view') }}</option>
              <option value="urban-street">{{ $t('urban-street') }}</option>
              <option value="fantasy-forest">{{ $t('fantasy-forest') }}</option>
            </select>
          </div>
        </div>
        <div class="card-footer text-right">
          <button type="button" class="btn btn-primary" :disabled="loading || !available" @click="createCover()">
            {{ $t('generate') }}
          </button>
        </div>
      </div>
      <div class="card" v-show="tab === 'covers'">
        <div class="card-body p-0 table-responsive">
          <div class="row">
            <div class="col-sm-4 col-md-3" v-for="(cover, index) in covers" v-bind:key="`cover_${index}`">
              <a :href="cover.url" target="_blank" class="d-inline-block p-2">
                <img :src="cover.url" class="w-100">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="#" ref="downloadLink" style="display:none;"></a>
  </div>
</template>
<script>
import AI from '../services/ai'
import moment from 'moment'

export default {
  name: 'LyricGenerator',
  data: function () {
    return {
      moment,
      tab: 'generator',
      style: 'synthwave-80s',
      color: 'neons',
      background: 'futuristic-cityscape',
      loading: false,
      blob: null,
      url: '',
      covers: [],
      available: 0
    }
  },
  methods: {
    getCovers: function () {
      AI.getAICovers().then(response => {
        this.covers = response.data.items
        this.available = response.data.available
      })
    },
    download: function () {
      fetch(this.url)
        .then(response => response.blob())
        .then(blob => {
          window.$(this.$refs.downloadLink).attr('href', window.URL.createObjectURL(blob))
          window.$(this.$refs.downloadLink).attr('download', `indiefy-cover-${this.style}-${this.color}-${this.background}-${new Date().getTime()}.jpg`)
          window.$(this.$refs.downloadLink)[0].click()
        })
    },
    createCover: function () {
      if (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite') {
        return this.$router.push('/upgrade?from=ai-cover')
      }

      this.url = ''
      this.loading = true

      AI.createCover({ style: this.style, color: this.color, background: this.background }).then((response) => {
        this.url = response.data.url
        this.loading = false
        this.getCovers()
      }).catch(() => {
        alert('An error occurred, please contact support')
        this.loading = false
      })
    }
  },
  mounted: function () {
    window.$('html, body').animate({
      scrollTop: 0
    }, 500)
  },
  created: function () {
    this.user = this.$user
    this.getCovers()
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.cover-container {
  width: 200px;
  height: 200px;
  background: #eee;
  display: inline-block;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/AICover.vue